"use client";

import { usePathname } from "next/navigation";
import { useLayoutEffect } from "react";
import posthog from "posthog-js";
import { captureRecoveryFragment } from "@/lib/abandoned-carts/recovery-fragment";
import { isPostHogSuppressedPath } from "@/lib/posthog-suppressed-path";

/**
 * Stoppt Session Recording auf Admin- und Recovery-Routen.
 * Replay ist global aus (`disable_session_recording`); hier nur noch hart stoppen,
 * falls eine ältere Session noch aufzeichnet. Kein `startSessionRecording` danach.
 */
export function PostHogAdminRouteGate() {
	const pathname = usePathname() ?? "";

	useLayoutEffect(() => {
		captureRecoveryFragment();
		if (!posthog.__loaded) {
			return;
		}

		if (isPostHogSuppressedPath(pathname)) {
			try {
				posthog.stopSessionRecording();
			} catch {
				// ignore
			}
		}
	}, [pathname]);

	return null;
}
